// extracted by mini-css-extract-plugin
export default {"root":"Favorite__root--2GJVi","favorite":"Favorite__favorite--3J9bc"};